import { useLiveData, useService } from '@toeverything/infra';

import { AppSidebarService } from '../../services/app-sidebar';
import { navHeaderStyle } from '../index.css';
import { SidebarSwitch } from './sidebar-switch';
import { useNavigate } from 'react-router-dom'

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);
  const navigate = useNavigate()

  return (
    <div className={navHeaderStyle} style={{ justifyContent: 'flex-start' }} data-open={open}>
      <SidebarSwitch show={open} />
      {/* <img style={{ width: '20px', height: '20px', marginRight: '7px', marginLeft: '2px' }} src={fIcon} /> */}
      <span style={{ fontFamily: 'serif', color: '#1d2025', fontWeight: 700, fontSize: '20px', cursor: 'pointer' }} onClick={() => navigate('/home')}>群智创新</span>
    </div>
  );
};

export * from './sidebar-switch';
